import { Link } from 'react-router'

export const RuleLink = ({ rule }) => (
  <Link to={`/settings/rules/${rule.id}`}>{rule.name}</Link>
)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/RuleLink/RuleLink.js